var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.answer)?_c('div',[_c('p',{staticClass:"text-base leading-6 text-green tracking-wide uppercase font-bebas text-lg tracking-wider"},[_vm._v(" "+_vm._s(_vm.question)+" ")]),_c('vue-markdown',{staticClass:"text-gray-700 text-base prose",attrs:{"source":_vm.answer}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }